import { EmbeddingRouterLinkDirectiveModule } from '@accredible-frontend-v2/embedding';
import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { FormSectionComponentModule } from '@accredible-frontend-v2/new-components/ui-common';
import { AccredibleLocaleDatePipeModule } from '@accredible-frontend-v2/pipes/locale-date';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { DirectorySettingsStore } from '../../store/directory-settings.store';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslocoDirective,
    EmbeddingRouterLinkDirectiveModule,
    FormSectionComponentModule,
    AccredibleButtonComponentModule,
    AccredibleIconComponentModule,
    AccredibleLocaleDatePipeModule,
  ],
  selector: 'db-marketing-content-settings',
  templateUrl: './marketing-content-settings.component.html',
  styleUrls: ['./marketing-content-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingContentSettingsComponent implements OnInit {
  private readonly _store = inject(DirectorySettingsStore);
  private readonly _language = inject(AccredibleLanguageService);

  directoryId = input.required<number>();

  marketingContent$ = this._store.marketingContent$;
  languageCode$ = this._language.languageCode$;

  ngOnInit(): void {
    this._store.loadDirectoryMarketingContent({ directoryId: this.directoryId() });
  }
}
